import React, { FC, useState, useLayoutEffect } from 'react';
import {
  sidebarConfig,
  useSidebarPinState,
  SidebarPinStateProvider,
  SidebarPage as BackstageSidebarPage,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { TMNATheme } from 'tmna-theme';
import { LocalStorage } from './localStorage';

const useSidebarStyles = makeStyles<
  TMNATheme,
  { sidebarConfig: typeof sidebarConfig; pinnedState: boolean }
>(theme => ({
  sidebarRoot: {
    [theme.breakpoints.up('sm')]: {
      '& > .MuiBox-root': {
        paddingLeft: props =>
          props.pinnedState
            ? props.sidebarConfig.drawerWidthOpen
            : props.sidebarConfig.drawerWidthClosed,
      },
    },
  },
}));

const OverrideSidebarProvider: FC<{
  pinnedState: boolean;
  setPinnedState: React.Dispatch<React.SetStateAction<boolean>>;
}> = props => {
  const [isPinned, setIsPinned] = React.useState(props.pinnedState);
  const { isMobile } = useSidebarPinState();

  useLayoutEffect(() => {
    props.setPinnedState(isPinned);
    LocalStorage.setSidebarPinState(isPinned);
  }, [isPinned, props]);

  return (
    <SidebarPinStateProvider
      value={{
        isPinned,
        toggleSidebarPinState: () => setIsPinned(!isPinned),
        isMobile,
      }}
    >
      {props.children}
    </SidebarPinStateProvider>
  );
};

export const SidebarPage: FC = props => {
  const [pinnedState, setPinnedState] = useState(
    LocalStorage.getSidebarPinState(),
  );

  const classes = useSidebarStyles({ pinnedState, sidebarConfig });
  return (
    <div className={classes.sidebarRoot}>
      <BackstageSidebarPage>
        <OverrideSidebarProvider
          pinnedState={pinnedState}
          setPinnedState={setPinnedState}
        >
          {props.children}
        </OverrideSidebarProvider>
      </BackstageSidebarPage>
    </div>
  );
};
